// Mock data para el sitio web gubernamental SETY Yucatán

export const eventos = [
  {
    id: 1,
    titulo: "Programa de Apoyo al Campo Yucateco 2025",
    descripcion: "La Secretaría de Economía y Trabajo impulsa el desarrollo agrícola con capacitación, tecnología y financiamiento para productores locales. Fortaleciendo las comunidades rurales de Yucatán.",
    imagen: "https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/xlykdgrl_f8c616e17d00e1491ebd364c020019a5.jpg",
    fecha: "15 de Marzo, 2025",
    categoria: "Campo"
  },
  {
    id: 2,
    titulo: "Yucatán Avanza con Infraestructura Rural Renovada",
    descripcion: "El gobierno impulsa el desarrollo de comunidades rurales con mejoras en caminos, electrificación y acceso a servicios básicos. Fortaleciendo la conectividad y calidad de vida en todo el estado.",
    imagen: "https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/4k81pc3z_10117_1_351.jpg",
    fecha: "20 de Marzo, 2025",
    categoria: "Infraestructura"
  },
  {
    id: 3,
    titulo: "Tecnología para Escuelas Rurales de Yucatán",
    descripcion: "Equipamiento digital y conectividad para escuelas en comunidades rurales. Reduciendo la brecha tecnológica y mejorando la calidad educativa en todo el estado.",
    imagen: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
    fecha: "25 de Marzo, 2025",
    categoria: "Educación"
  },
  {
    id: 4,
    titulo: "Modernización de Sistemas de Riego Agrícola",
    descripcion: "Implementación de sistemas de riego tecnificado para optimizar el uso del agua en cultivos. Aumentando la productividad y sostenibilidad del sector agrícola yucateco.",
    imagen: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&q=80",
    fecha: "30 de Marzo, 2025",
    categoria: "Campo"
  }
];

export const programasSociales = [
  {
    id: 1,
    nombre: "Yucatán sin Fronteras",
    descripcion: "Programa de movilidad laboral internacional que conecta talento yucateco con oportunidades globales",
    icono: "Globe",
    color: "from-slate-100 to-slate-200"
  },
  {
    id: 2,
    nombre: "Yucatán en México",
    descripcion: "Fortalecimiento de vínculos comerciales y laborales a nivel nacional para empresas yucatecas",
    icono: "MapPin",
    color: "from-gray-100 to-gray-200"
  },
  {
    id: 3,
    nombre: "Yucatán en el Mundo",
    descripcion: "Promoción internacional de productos y servicios yucatecos en mercados globales",
    icono: "Plane",
    color: "from-slate-100 to-slate-200"
  },
  {
    id: 4,
    nombre: "Impulsa tu Crecimiento",
    descripcion: "Capacitación empresarial y apoyo financiero para emprendedores y PYMES del estado",
    icono: "TrendingUp",
    color: "from-gray-100 to-gray-200"
  },
  {
    id: 5,
    nombre: "Profesionistas de Cooperativa",
    descripcion: "Desarrollo de cooperativas profesionales para fomentar el trabajo colaborativo y sostenible",
    icono: "Users",
    color: "from-slate-100 to-slate-200"
  }
];

export const servicios = [
  {
    id: 1,
    nombre: "Bolsa de Trabajo",
    descripcion: "Conectamos empresas con talento yucateco calificado",
    icono: "Briefcase",
    link: "/bolsa-trabajo"
  },
  {
    id: 2,
    nombre: "Servicios",
    descripcion: "Trámites y servicios gubernamentales en línea",
    icono: "FileText",
    link: "/servicios"
  },
  {
    id: 3,
    nombre: "Invierte en Yucatán",
    descripcion: "Oportunidades de inversión en el estado",
    icono: "Building2",
    link: "/invierte-yucatan"
  },
  {
    id: 4,
    nombre: "Normatividad SETY",
    descripcion: "Marco legal y regulatorio actualizado",
    icono: "Scale",
    link: "/normatividad"
  }
];

export const bannersRotativos = [
  {
    id: 1,
    titulo: "Plan Estatal de Desarrollo Renacimiento Maya",
    descripcion: "Conoce las estrategias de desarrollo para Yucatán 2024-2030",
    imagen: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80",
    link: "#"
  },
  {
    id: 2,
    titulo: "Catálogo de Servicios de Prevención 2025",
    descripcion: "Consulta los servicios disponibles para tu seguridad laboral",
    imagen: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80",
    link: "#"
  },
  {
    id: 3,
    titulo: "Reemplacamiento Vehicular 2025",
    descripcion: "Realiza tu trámite de forma rápida y segura",
    imagen: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=600&q=80",
    link: "#"
  }
];

export const vacantes = [
  {
    id: 1,
    puesto: "Ingeniero en Sistemas",
    empresa: "Gobierno de Yucatán",
    ubicacion: "Mérida, Yucatán",
    salario: "$15,000 - $20,000",
    tipo: "Tiempo completo",
    fecha: "Publicado hace 2 días"
  },
  {
    id: 2,
    puesto: "Contador Público",
    empresa: "SETY",
    ubicacion: "Mérida, Yucatán",
    salario: "$12,000 - $18,000",
    tipo: "Tiempo completo",
    fecha: "Publicado hace 5 días"
  },
  {
    id: 3,
    puesto: "Coordinador de Proyectos Sociales",
    empresa: "Secretaría de Desarrollo Social",
    ubicacion: "Valladolid, Yucatán",
    salario: "$14,000 - $19,000",
    tipo: "Tiempo completo",
    fecha: "Publicado hace 1 semana"
  }
];

export const noticias = [
  {
    id: 1,
    titulo: "Inicia la Semana de la Economía Digital 2025 en Yucatán",
    extracto: "La SETY impulsa la transformación digital de empresas yucatecas",
    fecha: "10 de Marzo, 2025",
    imagen: "https://customer-assets.emergentagent.com/job_gobierno-moderno/artifacts/xlykdgrl_f8c616e17d00e1491ebd364c020019a5.jpg"
  },
  {
    id: 2,
    titulo: "Récord en generación de empleos formales",
    extracto: "Yucatán supera las expectativas con 5,000 nuevos empleos",
    fecha: "8 de Marzo, 2025",
    imagen: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80"
  },
  {
    id: 3,
    titulo: "Nuevos apoyos para emprendedores yucatecos",
    extracto: "Programa de financiamiento beneficiará a 500 PYMES",
    fecha: "5 de Marzo, 2025",
    imagen: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&q=80"
  }
];
